import { render } from "./LoginOne.vue?vue&type=template&id=6b610f4f"
import script from "./LoginOne.vue?vue&type=script&lang=js"
export * from "./LoginOne.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__